/* eslint-disable max-classes-per-file */

export class ApiUrls {
    public static readonly ErrorUrl: string = '/api/error';
    public static readonly RootUrl: string = '/api';
    public static readonly JobList: string = '/api/job/list';
    public static readonly JobStopUrl: string = '/api/job/stop';
    public static readonly JobStartUrl: string = '/api/job/start';
    public static readonly JobParametersUrl: string = '/api/job/parameters';
    public static readonly JobSettingsUrl: string = '/api/job/settings';
    public static readonly JobTriggerCreateUrl: string = '/api/job/create';
    public static readonly JobTriggerDeleteUrl: string = '/api/job/delete';
    public static readonly CheckTriggerNameUrl: string = '/api/job/check-trigger-name';
    public static readonly JobCronValidation: string = '/api/Job/cron/validation';
    
    public static readonly ConfigurationUrl: string = '/api/configuration';

    public static readonly PermissionUrl: string = '/api/permission';
    public static readonly PermissionRoleUrl: string = '/api/permission/role';

    public static readonly ServiceDownloadFullLogsUrl: string = '/api/service/download-full-logs';
    public static readonly ServiceDownloadDayLogsUrl: string = '/api/service/download-day-logs';
    public static readonly ServiceDownloadSapImportsUrl: string = '/api/service/download-sap-imports';
    public static readonly ServiceDownloadSapExportsUrl: string = '/api/service/download-sap-exports';
    public static readonly ServiceSapImportDatesUrl: string = '/api/service/sap-import-dates';
    public static readonly ServiceSapExportDatesUrl: string = '/api/service/sap-export-dates';
    public static readonly ServiceDownloadMessagesUrl: string = '/api/service/download-messages';
    public static readonly ServiceDownloadDeadlettersUrl: string = '/api/service/download-deadletters';
    public static readonly ServiceDatesWithLogsUrl: string = '/api/service/dates';
    public static readonly ServiceLogFilesUrl: string = '/api/service/log-files';
    public static readonly ServiceDeleteLogFileUrl: string = '/api/service/log-file';
    public static readonly ServiceDownloadLogUrl: string = '/api/service/download-log';
    public static readonly ServiceDownloadLogGzUrl: string = '/api/service/download-log-gz';
    public static readonly ServiceMessagesDatesUrl: string = '/api/service/messages-dates';
    public static readonly ServiceMessagesLabelsUrl: string = '/api/service/message-labels';
    public static readonly ServiceMessagesTagsUrl: string = '/api/service/message-tags';
    public static readonly ServiceQueueDeadlettersUrl: string = '/api/service/input-queue-deadletters';
    public static readonly MessageStatisticsUrl: string = '/api/service/message-statistics';
    public static readonly QueueNamesUrl: string = '/api/service/queue-names';

    public static readonly MonitoringUrl: string = '/api/monitoring';

    public static readonly SignalRUserUrl: string = '/api/signalruser/';

    public static readonly SelfTestJobsUrl: string = '/api/selftest/jobs';
    public static readonly SelfTestDatabaseUrl: string = '/api/selftest/database';
    public static readonly SelfTestMessageBusUrl: string = '/api/selftest/messagebus';
    public static readonly SelfTestFlightEnzianChangesQueue: string = '/api/selftest/flight-enzian-changes-queue';
    public static readonly SelfTestWeightQueue: string = '/api/selftest/weight-queue';
    public static readonly SelfTestAirportQueue: string = '/api/selftest/airport-queue';
    public static readonly SelfTestIntegrationHealthUrl: string = '/api/selftest/integration-health';
    public static readonly SelfTestMessageTypeHealthUrl: string = '/api/selftest/message-type-health';
    public static readonly ServiceRestartSchedulerUrl: string = '/api/service/restart-scheduler';
    public static readonly ServiceQueueStatisticsUrl: string = '/api/service/input-queue-statistics';

    public static readonly AircraftsUrl: string = '/api/flight/aircraft';
    public static readonly FlightsUrl: string = '/api/flight';
    public static readonly FlightsLegacyUrl: string = '/api/flight/legacy';
    public static readonly FlightsEnzianUrl: string = '/api/flight/enzian';
    public static readonly FlightsFullUrl: string = '/api/flight/full';
    public static readonly FlightUrl: string = '/api/flight/{id}';
    public static readonly FlightDelaysUrl: string = '/api/flight/{id}/delays';
    public static readonly FlightCrewUrl: string = '/api/flight/{id}/crew';
    public static readonly FlightCrewEbolaAttestationUrl: string = '/api/flight/{id}/crew/ebola-attestation';
    public static readonly FlightCrewEbolaAttestationIsRequiredUrl: string = '/api/flight/{id}/crew/ebola-attestation/is-required';
    public static readonly FlightSeatSummariesUrl: string = '/api/flight/{id}/seat-summaries';
    public static readonly FlightPnlEmailUrl: string = '/api/flight/{id}/pnl-email';
    public static readonly FlightSeatSummariesHistoryUrl: string = '/api/flight/{id}/seat-summaries/history';
    public static readonly FlightSeatSummariesImportUrl: string = '/api/flight/{id}/seat-summaries/import';
    public static readonly FlightCabinVersionsUrl: string = '/api/flight/{id}/cabin-versions';
    public static readonly FlightNetlineOpsXmlUrl: string = '/api/flight/{id}/netline-ops-xml';
    public static readonly FlightWeightUrl: string = '/api/flight/{id}/weight';
    public static readonly FlightWeightHistoryUrl: string = '/api/flight/{id}/weight/history';
    public static readonly FlightWeightCalculationsUrl: string = '/api/flight/{id}/weight/calculations';
    public static readonly FlightWeightSendStateUrl: string = '/api/flight/{id}/weight/send-state';
    public static readonly FlightCargoUrl: string = '/api/flight/{id}/cargo';
    public static readonly FlightPantryCodeUrl: string = '/api/flight/{id}/pantry-code';
    public static readonly FlightPantryCodeOptionsUrl: string = '/api/flight/{id}/pantry-codes';
    public static readonly FlightWeightInputHistoryUrl: string = '/api/flight/{id}/weight/input-history';
    public static readonly FlightWeightPublishUrl: string = '/api/flight/{id}/weight/publish';
    public static readonly FlightWeightForceResendUrl: string = '/api/flight/{id}/weight/force-resend';
    public static readonly FlightEnzianInfoXmlUrl: string = '/api/flight/enzian-xml/{id}';
    public static readonly FlightMessageHistoryUrl: string = '/api/flight/{id}/messages';
    public static readonly FlightRebuildUrl: string = '/api/flight/{id}/rebuild';
    public static readonly FlightResyncEnzianUrl: string = '/api/flight/{id}/enzian-resync';
    public static readonly FlightPublishUrl: string = '/api/flight/{id}/publish';
    public static readonly FlightRePublishUrl: string = '/api/flight/{id}/republish';
    public static readonly ManualFlightCreateUrl: string = '/api/flight/manual';
    public static readonly ManualFlightLookupsUrl: string = '/api/flight/manual/lookups';
    public static readonly ManualFlightNextLegUrl: string = '/api/flight/manual/next-leg';
    public static readonly ManualFlightRouteHintsUrl: string = '/api/flight/manual/route-hints';
    public static readonly ManualFlightNumberHintsUrl: string = '/api/flight/manual/flight-number-hints';
    public static readonly ManualFlightConfigurationHintUrl: string = '/api/flight/manual/configuration-hint';
    public static readonly ManualFlightUrl: string = '/api/flight/{id}/manual';
    public static readonly ManualFlightCancelUrl: string = '/api/flight/{id}/manual/cancel';
    public static readonly MaintenancesUrl: string = '/api/flight/aircraft-maintenance';

    public static readonly EmailsUrl = '/api/email';
    public static readonly EmailBodyUrl = '/api/email/body';
    public static readonly EmailAttachmentsUrl = '/api/email/attachments';
    public static readonly EmailAttachmentDownloadUrl = '/api/email/attachment';
    public static readonly EmailUpdateStatusUrl = '/api/email/update-status';

    public static readonly AirportUrl: string = '/api/airport';
    public static readonly AirportGridUrl: string = '/api/airport/grid';

    public static readonly CarriersUrl: string = '/api/carrier';
    public static readonly AircraftFamiliesUrl: string = '/api/aircraftfamily';
    public static readonly PantryCarrierCodesUrl: string = '/api/pantry/carrier-codes';
    public static readonly PantryStationCodesUrl: string = '/api/pantry/station-codes';
    public static readonly PantryStationCodeLogUrl: string = '/api/pantry/station-code-log';
    public static readonly PantryFutureDestinationStatusUrl: string = '/api/pantry/future-destination-pantry-status';
    public static readonly PantryStationCodesImportUrl: string = '/api/pantry/station-codes/import';

    public static readonly AircraftListUrl: string = '/api/aircraft';
    public static readonly AircraftUpdateUrl: string = '/api/aircraft';
    public static readonly AircraftCreateUrl: string = '/api/aircraft';
    public static readonly AircraftTypesUrl: string = '/api/aircraft/types';
    public static readonly AircraftTypeGroupsUrl: string = '/api/aircraft/types/groups';
    public static readonly AircraftNightstopCorrectionUrl: string = '/api/aircraft/nightstop-correction';
    public static readonly AircraftPantryCodesUrl: string = '/api/aircraftpantry/pantry-codes';
    public static readonly AircraftPantryRowsUrl: string = '/api/aircraftpantry/rows';
    public static readonly AircraftPantryRowsLogUrl: string = '/api/aircraftpantry/rows-log';
    public static readonly AircraftPantryRowsImportUrl: string = '/api/aircraftpantry/rows/import';
    public static readonly AircraftPantryRowsDeleteAllUrl: string = '/api/aircraftpantry/rows';
    public static readonly WaterCorrectionRowsUrl: string = '/api/watercorrection/rows';
    public static readonly WaterCorrectionRowsLogUrl: string = '/api/watercorrection/rows-log';
    public static readonly AircraftNightstopCorrectionLogUrl: string = '/api/aircraft/nightstop-correction-log';

    public static readonly WaterQuantityGroupsUrl: string = '/api/waterquantity/aircraft-type-groups';
    public static readonly WaterQuantityLegsUrl: string = '/api/waterquantity/station-legs';
    public static readonly WaterQuantityLegQuantitiesUrl: string = '/api/waterquantity/station-leg-quantities';
    public static readonly WaterQuantityLegLogUrl: string = '/api/waterquantity/station-leg-quantity-log';
    public static readonly WaterQuantityStationNoUpliftUrl: string = '/api/waterquantity/station-no-water-uplift';
    public static readonly WaterQuantityFutureFlightStatusUrl: string = '/api/waterquantity/future-flight-water-quantity-status';
    public static readonly WaterQuantityImportUrl: string = '/api/waterquantity/import';
    public static readonly AirportSearchUrl: string = '/api/airport/search';
    public static readonly AirportLookupUrl: string = '/api/airport/lookup';

    public static readonly PeopleAssistEntriesUrl: string = '/api/peopleassist/entries';
    public static readonly PeopleAssistEntryDetailUrl: string = '/api/peopleassist/entries/{kind}/{id}';
    public static readonly PeopleAssistLiveFormsUrl: string = '/api/peopleassist/live/forms';
    public static readonly PeopleAssistLiveFormDetailUrl: string = '/api/peopleassist/live/forms/{id}';
    public static readonly PeopleAssistLiveFormByNumberUrl: string = '/api/peopleassist/live/forms/by-number/{number}';
    public static readonly PeopleAssistIllnessPersonsUrl: string = '/api/peopleassist/illness/persons';
    public static readonly PeopleAssistIllnessPersonDetailUrl: string = '/api/peopleassist/illness/persons/{personCode}';
    public static readonly PeopleAssistIllnessLiveFormsUrl: string = '/api/peopleassist/illness/persons/{personCode}/live';

    public static readonly FileExplorerListUrl: string = '/api/fileexplorer/list';

    public static readonly KafkaViewerTriggersUrl: string = '/api/kafkaviewer/triggers';
    public static readonly KafkaViewerMessagesUrl: string = '/api/kafkaviewer/messages';
}

export class HubAirport {
    public static readonly Icao: string = 'LSZH';
    public static readonly Iata: string = 'ZRH';
}

export class PrincipalConfig {
    public static readonly ReportGridStateKey: string = 'reportGridState';
    public static readonly ReportFiltersKey: string = 'reportFiltersKey';
    public static readonly FlightFiltersKey: string = 'flightFiltersKey';
    public static readonly FlightsListGroup: string = 'flightsListGroup';
    public static readonly FlightsGantGroup: string = 'flightsGantGroup';
    public static readonly flightsScheduleGroup: string = 'flightsScheduleGroup';
    public static readonly viewGroup: string = 'viewGroup';
    public static readonly darkMode: string = 'darkMode';
    public static readonly feature: string = 'feature';
    public static readonly EnablePermissionsCheck: string = 'EnablePermissionsCheck';
    public static readonly EnableManualFlights: string = 'EnableManualFlights';
    public static readonly EnableFlightsNeedingAttention: string = 'EnableFlightsNeedingAttention';
    public static readonly FlightPnlEmailGroup: string = 'FlightPnlEmail';
    public static readonly FlightPnlEmailFrom: string = 'From';
    public static readonly FlightPnlEmailTo: string = 'To';
    public static readonly FlightPnlEmailSubject: string = 'Subject';
    public static readonly FlightPnlEmailBody: string = 'Body';
    public static readonly StationsListGroup: string = 'stationsListGroup';
    public static readonly AircraftsListGroup: string = 'aircraftsListGroup';
}

export class KeyboardKeys {
    public static readonly ENTER: number = 13;
    public static readonly ESCAPE: number = 27;
    public static readonly BACKSPACE: number = 8;
}

export class ComponentUrls {
    public static readonly HubUrl: string = '/hubs/notification';
}

export class DateFormat {
    public static readonly JSON: string = 'YYYY-MM-DD';
    public static readonly DateTime: string = 'DD.MM.YYYY HH:mm';
    public static readonly Time: string = 'HH:mm';
}

export class DateTime {
    public static readonly jsonDateFormat: string = 'YYYY-MM-DD';
    public static readonly viewDateFormat: string = 'DD.MM.YYYY';
    public static readonly jsonFullFormat: string = 'YYYY-MM-DD HH:mm:ss';
    public static readonly jsonDateTimeFormat: string = 'YYYY-MM-DDTHH:mm:ssZ';
    public static readonly viewFullFormat: string = 'DD.MM.YYYY HH:mm';
    public static readonly monthPeriodFormat: string = 'YYYY M';
    public static readonly viewMonthFormat: string = 'MM.YYYY';
    public static readonly monthPeriodFullFormat: string = 'YYYY-MM';
    public static readonly timeFormat: string = 'HH:mm';
    public static readonly minDate: string = '01.01.2017';
}

export class Environment {
    public static readonly Development: string = 'DEVELOPMENT';
    public static readonly Staging: string = 'STAGING';
    public static readonly Production: string = 'PRODUCTION';
}

export class ParameterType {
    public static readonly DateTime: string = 'DateTime';
    public static readonly Date: string = 'Date';
    public static readonly Boolean: string = 'Boolean';
    public static readonly MultiLine: string = 'Multiline';
    public static readonly SingleLine: string = 'String';
    public static readonly Integer: string = 'Integer';
    public static readonly Enum: string = 'Enum';
    public static readonly CustomDropdown: string = 'CustomDropdown';
}

export class Status {
    public static readonly success: string = 'Success';
    public static readonly warning: string = 'Warning';
    public static readonly fail: string = 'Fail';
}

export class JobMisfireInstruction {
    public static readonly default: string = 'Default';
    public static readonly doNothing: string = 'DoNothing';
    public static readonly fireAndProceed: string = 'FireAndProceed';
    public static readonly ignoreMisfires: string = 'IgnoreMisfires';
}

export class SignalREvents {
    public static readonly jobStatusChanged: string = 'jobStatusChanged';
    public static readonly jobProgressMaxValueChanged: string = 'jobProgressMaxValueChanged';
    public static readonly jobProgressValueChanged: string = 'jobProgressValueChanged';
    public static readonly sendJobTimeline: string = 'sendJobTimeline';
}

export class KeyboardCodes {
    public static readonly ENTER: string = 'Enter';
    public static readonly ESCAPE: string = 'Escape';
    public static readonly BACKSPACE: string = 'Backspace';
}
